export default {
  renewal_date_override:"Fecha de renovación modificada",
  membership_term_start:"Inicio del período de membresía",
  joined_at:"Fecha de alta",
  billingFrequency:"Frecuencia de facturación",
  contractMonths:"Duración del contrato (meses, 1–120)",
  billingOptions:"Opciones de facturación",
  accountHelp:"Permitir cargar las compras aptas a la cuenta responsable configurada.",
  duesHelp:"Inscribir las cuotas en la facturación periódica. La membresía sigue vinculada a este socio.",
  initiationHelp:"Incluir la cuota de inscripción una sola vez en el ciclo de facturación correspondiente.",

  accountCharging:"Permitir cargos a cuenta",
  duesEnrolment:"Inscribir en facturación periódica e incluir cuotas del socio",
  initiationFee:"Incluir la cuota de inscripción en el ciclo de facturación",
  feesHelp:"Las cuotas periódicas y de inscripción utilizan la cuenta responsable. Desactivar los cargos discrecionales no cancela la inscripción de cuotas.",
  status_open:"Pendiente",
  status_paid:"Pagado",
  status_partially_settled:"Liquidado parcialmente",
  status_partially_paid:"Pagado parcialmente",
  status_pending:"Pendiente",
  status_overdue:"Vencido",
  status_void:"Anulado",
  status_refunded:"Reembolsado",
  status_reversed:"Revertido",
  status_cancelled:"Cancelado",
  status_posted:"Contabilizado",
  status_invoiced:"Facturado",
  status_settled:"Liquidado",
  status_written_off:"Dado de baja",
  status_unknown:"Estado no disponible",

  billing_option_invalid:"Las opciones de facturación deben estar activadas o desactivadas.",
  billing_payer_invalid:"Selecciona un socio válido como responsable de la cuenta.",
  "category": "Categoría de socio",
  "adult": "Adulto",
  "child": "Menor",
  "unclassified": "Sin clasificar (antiguo)",
  "requirePayer": "Exigir otro socio como responsable de la cuenta",
  "thisMember": "Este socio",
  "anotherMember": "Otro socio",
  "accountPayer": "Responsable de la cuenta",
  "search": "Buscar por nombre o número de socio",
  "summary": "Los cargos de cuenta permitidos de {member} se facturarán a la cuenta de {payer}.",
  "billedTo": "Facturado a {payer}",
  "forMember": "Para {member}",
  "chargeAccount": "Cargar a la cuenta de {payer} · Para {member}",
  "linkedCharges": "Cargos facturados a otro socio",
  "searching": "Buscando socios…",
  "typeToSearch": "Escribe al menos 2 caracteres para buscar.",
  "noResults": "No se encontraron socios.",
  "billing_forbidden": "Necesitas permiso para cambiar la responsabilidad de facturación.",
  "billing_member_not_found": "El socio o responsable no pertenece a este club.",
  "billing_member_inactive": "El socio que recibe el servicio está inactivo.",
  "billing_account_charging_disabled": "Los cargos a cuenta están desactivados para este socio. Elige efectivo/tarjeta o pide al personal que los active.",
  "billing_another_payer_required": "Este tipo de membresía exige otro responsable de cuenta. Selecciona un socio apto.",
  "billing_payer_required": "Selecciona un responsable de cuenta apto antes de activar la facturación a cuenta.",
  "billing_override_forbidden": "No puedes sustituir al responsable configurado.",
  "billing_payer_inactive": "El responsable está inactivo. Selecciona otro responsable apto.",
  "billing_payer_chain": "El responsable debe usar su propia cuenta y no puede redirigir cargos a otro socio.",
  "billing_payer_ineligible": "El responsable debe tener los cargos a cuenta activados y una cuenta apta.",
  "billing_account_ineligible": "La cuenta responsable no existe o está inactiva. Pide al personal que configure una cuenta apta.",
  "billing_credit_limit": "Este cargo supera el límite de crédito de la cuenta responsable. Elige efectivo/tarjeta o contacta con el personal.",
  "billing_mode_invalid": "Elige Este socio u Otro socio.",
  "billing_payer_self": "Elige Este socio para usar tu propia cuenta.",
  "billing_policy_changed": "La configuración de facturación ha cambiado. Vuelve a cargar el socio antes de guardar.",
  "billing_category_required": "Selecciona Adulto o Menor para el nuevo tipo de membresía.",
  "billing_category_invalid": "Selecciona una categoría de socio válida.",
  "billing_requirement_invalid": "Selecciona un requisito de responsable válido."
};
